import { Chip, Tooltip } from '@mui/material';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import {
    EXTRACTION_STATUS_COLOR, EXTRACTION_STATUS_LABEL, ExtractionStatus,
    SUBMISSION_STATUS_COLOR, SUBMISSION_STATUS_LABEL, SubmissionStatus, SubmissionType,
} from '../../../model/ser/ser-enums';

export function SubmissionStatusChip({ statusId, label }: { statusId: number; label?: string }) {
    const color = SUBMISSION_STATUS_COLOR[statusId as SubmissionStatus]?.chip ?? 'default';
    return <Chip size="small" color={color} label={SUBMISSION_STATUS_LABEL[statusId as SubmissionStatus] ?? label ?? '—'} sx={{ fontWeight: 600 }} />;
}

// Rotina não tem destaque; Urgência aparece como chip de alerta
export function SubmissionTypeChip({ type, compact }: { type: number; compact?: boolean }) {
    if (type !== SubmissionType.Urgencia) return null;
    return compact
        ? (
            <Tooltip title="Urgência">
                <PriorityHighIcon fontSize="small" color="warning" aria-label="Urgência" />
            </Tooltip>
        )
        : <Chip size="small" color="warning" variant="outlined" icon={<PriorityHighIcon />} label="Urgência" />;
}

export function ExtractionStatusChip({ status }: { status?: number }) {
    if (!status) return null;
    const color = EXTRACTION_STATUS_COLOR[status as ExtractionStatus]?.chip ?? 'default';
    return <Chip size="small" variant="outlined" color={color} label={EXTRACTION_STATUS_LABEL[status as ExtractionStatus] ?? '—'} />;
}
